import { useContext, useEffect, useState } from 'react'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'
import { Controller } from 'react-hook-form'
import { Input } from 'alurkerja-ui'

export default function KeyActivitiesJobDesc() {
  const { setValue, control, watch } = useContext<CustomComponentContextType>(CustomComponentContext)
  const [jumlahKeyActivitiesJobDesc] = watch(['jumlahKeyActivitiesJobDesc'])
  const [jumlahKey, setJumlahKey] = useState<number>(0)
  const [keyActivities, setKeyActivities] = useState<string[]>([])
  const [jobDesc, setJobDesc] = useState<string[]>([])

  useEffect(() => {
    if (jumlahKeyActivitiesJobDesc) {
      setJumlahKey(Number(jumlahKeyActivitiesJobDesc))
    } else {
      setJumlahKey(0)
    }
  }, [jumlahKeyActivitiesJobDesc])

  useEffect(() => {
    setValue('KeyActivities', keyActivities)
  }, [keyActivities])

  useEffect(() => {
    setValue('JobDesc', jobDesc)
  }, [jobDesc])

  const classNamesLabel = "after:content-['*'] after:text-red-400 after:text-sm font-medium"

  const changeKeyActivities = (index: number, value: string) => {
    setKeyActivities(prev => {
      const newActivities = [...prev]
      newActivities[index] = value

      return newActivities
    })
  }

  const changeJobDesc = (index: number, value: string) => {
    setJobDesc(prev => {
      const newJobDesc = [...prev]
      newJobDesc[index] = value

      return newJobDesc
    })
  }

  return (
    <div className="flex flex-col">
      {jumlahKey > 0 &&
        Array.from({ length: jumlahKey }).map((_, index) => (
          <div key={index}>
            <div className="grid space-x-2">
              <div data-testid={`KeyActivities-${index}`}>
                <label htmlFor={`KeyActivities-${index}`} className={classNamesLabel}>
                  Key Activities {index + 1}
                </label>
                <Controller
                  name={`KeyActivities[${index}]`}
                  control={control}
                  render={({ fieldState }) => (
                    <Input
                      id={`KeyActivities-${index}`}
                      type="text"
                      placeholder="Masukkan key activities"
                      className="w-full"
                      onChange={e => changeKeyActivities(index, e.target.value)}
                      required
                    />
                  )}
                />
              </div>
            </div>

            <div className="grid space-x-2">
              <div data-testid={`JobDesc-${index}`}>
                <label htmlFor={`JobDesc-${index}`} className={classNamesLabel}>
                  Job Desc {index + 1}
                </label>
                <Controller
                  name={`JobDesc[${index}]`}
                  control={control}
                  render={({ fieldState }) => (
                    <Input
                      id={`JobDesc-${index}`}
                      type="text"
                      placeholder="Masukkan job desc"
                      className="w-full"
                      textArea
                      onChange={e => changeJobDesc(index, e.target.value)}
                      required
                    />
                  )}
                />
              </div>
            </div>
          </div>
        ))}
    </div>
  )
}
